<placeme-layout-seo [seo]="'jobsPage.seo' | translate">
  <placeme-jumbotron [seo]="'jobsPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content jobs">
    <markdown class="page-markdown" [data]="'jobsPage.content' | translate"></markdown>

    <div class="jobs__container">
      <a class="card" [routerLink]="[item.slug] | localize" *ngFor="let item of jobs; trackBy: trackBySlug">
        <div class="card__img">
          <img
            *ngIf="item"
            [src]="
              item?.seo
                | seoImageUrl
                  : {
                      text: false,
                      format: 'rectangle',
                      logo: true,
                      category: item?.__typename
                    }
            "
            [alt]="item?.seo?.title"
            [title]="item?.seo?.title"
          />
        </div>
        <div class="card__container">
          <h3 class="card__container__title">{{ item?.seo?.title }}</h3>
          <p class="card__container__description">{{ item?.seo?.description }}</p>
        </div>
      </a>
    </div>
    <p *ngIf="jobs && !jobs.length" class="jobs__empty">{{ 'jobsPage.emptyContent' | translate }}</p>
  </section>
</placeme-layout-seo>
